import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/HomeView.vue"),
    meta: { public: true, home: true },
  },
  {
    path: "/generator",
    name: "generator",
    component: () =>
      import(/* webpackChunkName: "generator" */ "../views/GeneratorView.vue"),
  },
  {
    path: "/generate",
    name: "generate",
    component: () =>
      import(/* webpackChunkName: "generate" */ "../views/GenerateView.vue"),
  },
  {
    path: "/workflows",
    name: "workflows",
    component: () =>
      import(/* webpackChunkName: "workflows" */ "../views/WorkflowListView.vue"),
  },
  {
    path: "/workflows/create",
    name: "workflow-create",
    component: () =>
      import(/* webpackChunkName: "workflows" */ "../views/WorkflowEditView.vue"),
  },
  {
    path: "/workflows/:slug/edit",
    name: "workflow-edit",
    component: () =>
      import(/* webpackChunkName: "workflows" */ "../views/WorkflowEditView.vue"),
  },
  {
    path: "/workflows/:slug/use",
    name: "workflow-use",
    component: () =>
      import(/* webpackChunkName: "workflows" */ "../views/WorkflowUseView.vue"),
  },
  {
    path: "/records",
    name: "records",
    component: () =>
      import(/* webpackChunkName: "records" */ "../views/RecordListView.vue"),
  },
  {
    path: "/users",
    name: "users",
    component: () =>
      import(/* webpackChunkName: "users" */ "../views/UserListView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
